// USSDStart is the single shared entry point every partner's USSD sub-flows are reached through (Buy
// Cover, Manage Policy, Claims, Learn More for Mthunzi; the equivalent per-partner menu for anyone else) -
// simulating anything else directly would skip its customer/policy lookup and nav wiring, so this is the
// only flow a business user should ever simulate directly. A flow's UUID is different per org (Mthunzi's
// USSDStart and Samba's USSDStart are different flows on different orgs), so this is the flow's NAME, not
// a specific org's UUID - mailroom's loadFlowByRef resolves either a UUID or a name, falling back to a
// by-name lookup scoped to whichever org the request's own `org` param resolves to.
export const USSDSTART_FLOW_REF = 'USSDStart'

// How often the Sessions/Chat tabs silently refetch while a business user has them open, so an actively
// progressing customer session shows up without a manual page refresh. No push mechanism (SSE/websocket)
// exists on mailroom's business API - this view is low-traffic and support-facing, so plain polling is
// the right-sized fix rather than building one.
export const LIVE_POLL_INTERVAL_MS = 5000
